import { useTheme } from '@emotion/react'
import styled from '@emotion/styled'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import Footer from '@segment/templates/Footer'
import Navigation from '@segment/templates/Navigation'

import Layout from '@segment/next-shared/layout'

import ogImage from '../assets/PricingOgImage.png'

import Hero from './components/Hero'
import PlansCards from './components/PlansCards'
import LogoCarousel from './components/LogoCarousel'
import ArtificialIntelligence from './components/ArtificialIntelligence'
import Faq from './components/Faq'
import GettingStarted from './components/GettingStarted'

const Pricing = () => {
  const theme = useTheme()
  return (
    <AppearanceProvider appearance="twilioLight">
      <Layout
        pageTitle="Twilio Segment Plans & Pricing | Twilio Segment"
        pageDescription="Discover options to enable your organization to create unified profiles, build audiences, & orchestrate personalized journeys. Compare pricing plans from Twilio Segment"
        pageOG={ogImage}
        themeColor={theme.palette.neutrals.white[100]}
      >
        <Navigation />
        <Hero />
        <Main>
          <PlansCards />
          <LogoCarousel />
          <ArtificialIntelligence />
          <Faq />
          <GettingStarted />
        </Main>
      </Layout>
      <Footer />
    </AppearanceProvider>
  )
}

const Main = styled.main`
  background-color: ${({ theme }) => theme.palette.neutrals.white[100]};
`

export default Pricing
